import { apiConstructor as api } from '@/api/apiConstructor';
import { Tag } from '@/types/tag';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function addTag(name: string): Promise<Tag> {
  const params: AxiosRequestConfig = { params: { name } };
  const response: AxiosResponse = await api.post('tags', params);
  return response.data;
}

export async function searchTags(term: string): Promise<Tag[]> {
  const params: AxiosRequestConfig = { params: { q: term } };
  const response: AxiosResponse = await api.get('tags/search', params);
  return response.data;
}
